module.exports = __webpack_public_path__ + "img/webdevelopment.9a3b3c1b.jpg";